export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind, Message} from 'kpc';
import type {MessageSendPayload} from 'kpc';

interface Props {
    value?: string
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {value: ''};
    }

    @bind
    onMessageSend(payload: MessageSendPayload) {
        Message.success('发送：' + payload.value);
    }
}